import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemAvailabilityService {
  constructor(private readonly httpClient: HttpClient) {}

  public getApplicationSystemAvailability(): Observable<any> {
    return this.httpClient.get<boolean>('/SystemAvailability/GetApplicationSystemAvailability');
  }

  public getOnlinePaymentSystemAvailability(): Observable<any> {
    return this.httpClient.get<boolean>('/SystemAvailability/GetOnlinePaymentSystemAvailability');
  }
}
